module.exports = __webpack_public_path__ + "482d7ea0ed12fffbd3dce934960b5db3.svg";